import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import COMPANY_LOGO from "./companyLogoBase64";

export const openPolicyPdf = async (policy) => {
  if (!policy) return;

  const isTitleLong = (title = "") => {
    return title.trim().split(/\s+/).length > 5;
  };

  const longTitle = isTitleLong(policy.title);
  const pdf = new jsPDF("p", "mm", "a4");
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const marginX = 15;
  const contentWidth = pageWidth - marginX * 2;
  const headerHeight = 25;
  const footerHeight = 12;
  const startY = headerHeight + 4;
  const endY = pageHeight - footerHeight - 10;

  let cursorY = startY;
  let pageNumber = 1;

  /* HEADER ================= */
  const drawHeader = () => {
    pdf.addImage(COMPANY_LOGO, "PNG", marginX, 10, 30, 10);
    pdf.setFontSize(12);
    pdf.setFont("helvetica", "bold");

    pdf.text(
      longTitle ? "" : (policy.title || "Policy Document"),
      pageWidth - marginX,
      20,
      { align: "right" }
    );

    pdf.line(marginX, headerHeight, pageWidth - marginX, headerHeight);
  };

  /* FOOTER ================= */
  const drawFooter = () => {
    pdf.setFontSize(9);
    pdf.text(
      `Page ${pageNumber}`,
      pageWidth / 2,
      pageHeight - 5,
      { align: "center" }
    );
    pdf.line(
      marginX,
      pageHeight - footerHeight,
      pageWidth - marginX,
      pageHeight - footerHeight
    );
  };

  const addNewPage = () => {
    pdf.addPage();
    pageNumber++;
    cursorY = startY;
    pdf.setTextColor(0, 0, 0);
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(11);

    drawHeader();
    drawFooter();
  };

  drawHeader();
  drawFooter();

  pdf.setFontSize(14);
  pdf.setFont("helvetica", "bold");

  if (policy.version) {
    pdf.setFontSize(11);
    pdf.setFont("helvetica", "normal");
    pdf.text(`Version: ${policy.version}`, marginX, cursorY);
    cursorY += 8;
  }

  const convertImagesToBase64 = async (html) => {
    const temp = document.createElement("div");
    temp.innerHTML = html;

    const images = temp.querySelectorAll("img");
    console.log("Total images found===========================", images.length);
    const toBase64ViaCanvas = (url) =>
      new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = "anonymous";

        img.onload = () => {
          try {
            const canvas = document.createElement("canvas");
            canvas.width = img.naturalWidth || img.width;
            canvas.height = img.naturalHeight || img.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            const dataUrl = canvas.toDataURL("image/png");
            resolve(dataUrl);
          } catch (e) {
            console.warn("Canvas toDataURL failed, using fallback 1x1 image", e);
            resolve(
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/5+hHgAHggJ/PchI7wAAAABJRU5ErkJggg=="
            );
          }
        };

        img.onerror = () => {
          console.warn("Image load failed for===================", url);
          resolve(
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/5+hHgAHggJ/PchI7wAAAABJRU5ErkJggg=="
          );
        };
        img.src = url + (url.includes("?") ? "&" : "?") + "ts=" + Date.now();
      });

    for (let i = 0; i < images.length; i++) {
      const img = images[i];
      try {
        const src = img.getAttribute("src");
        console.log(`Processing image ${i}:`, src);

        if (!src || src.startsWith("data:")) {
          if (src?.startsWith("data:")) {
            console.log(`Image ${i} already in base64 format`);
          }
          continue;
        }
        const dataUrl = await toBase64ViaCanvas(src);
        img.setAttribute("src", dataUrl);
        console.log(`Image ${i} converted via canvas`);
      } catch (error) {
        console.warn(`Image conversion failed for index ${i}:`, error);
      }
    }

    return temp.innerHTML;
  };

  let contentHtml = policy.contentHtml || "";
  if (longTitle && policy.title) {
    contentHtml = `
    <h1 style="text-align:center;">
      ${policy.title}
    </h1>
    ${contentHtml}
  `;
  }

  const convertedHtml = await convertImagesToBase64(contentHtml);
  const tempContainer = document.createElement("div");
  tempContainer.style.position = "absolute";
  tempContainer.style.left = "-9999px";
  tempContainer.style.top = "0";
  tempContainer.style.width = `${contentWidth}mm`;
  tempContainer.style.padding = "0";
  tempContainer.style.margin = "0";
  tempContainer.innerHTML = convertedHtml;

  tempContainer.style.fontSize = "14px";
  tempContainer.style.fontFamily = "helvetica, Arial, sans-serif";
  tempContainer.style.lineHeight = "1.6";
  tempContainer.style.color = "#000";
  tempContainer.style.backgroundColor = "#fff";

  const tableStyles = document.createElement("style");
  tableStyles.innerHTML = `
  div[style*="position: absolute"] * {
    box-sizing: border-box !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  
  /* Headings H1-H5 */
 div[style*="position: absolute"] h1 {
  font-size: 22px !important;
  font-weight: bold !important;
  font-family: helvetica, arial, sans-serif !important;
  line-height: 1.25 !important;
  margin: 6px 0 12px 0 !important;
  color: #000 !important;
  text-align: center !important;
}
  div[style*="position: absolute"] h2 {
    font-size: 20px !important;
    font-weight: bold !important;
    font-family: helvetica, arial, sans-serif !important;
    line-height: 1.4 !important;
    margin: 18px 0 8px 0 !important;
    color: #000 !important;
  }
  div[style*="position: absolute"] h3 {
    font-size: 18px !important;
    font-weight: bold !important;
    font-family: helvetica, arial, sans-serif !important;
    line-height: 1.4 !important;
    margin: 16px 0 7px 0 !important;
    color: #000 !important;
  }
  div[style*="position: absolute"] h4 {
    font-size: 16px !important;
    font-weight: bold !important;
    font-family: helvetica, arial, sans-serif !important;
    line-height: 1.5 !important;
    margin: 14px 0 6px 0 !important;
    color: #000 !important;
  }
  div[style*="position: absolute"] h5 {
    font-size: 14px !important;
    font-weight: bold !important;
    font-family: helvetica, arial, sans-serif !important;
    line-height: 1.5 !important;
    margin: 12px 0 5px 0 !important;
    color: #000 !important;
  }
  
  /* Paragraphs & Text */
  div[style*="position: absolute"] p {
    margin: 8px 0 !important;
    text-align: justify !important;
    line-height: 1.8 !important;
    font-size: 14px !important;
  }
  
  /* Tables */
  div[style*="position: absolute"] table {
    width: 100% !important;
    border-collapse: collapse !important;
    margin: 12px 0 !important;
  }
  div[style*="position: absolute"] table td,
  div[style*="position: absolute"] table th {
    border: 1px solid #000 !important;
    padding: 6px 8px !important;
    font-size: 10px !important;
    text-align: left !important;
  }
  
  /* Lists */
  div[style*="position: absolute"] ul, 
  div[style*="position: absolute"] ol {
    margin: 10px 0 10px 20px !important;
    padding-left: 20px !important;
  }
  div[style*="position: absolute"] li {
    margin: 4px 0 !important;
    font-size: 11px !important;
    line-height: 1.5 !important;
  }
  
  /* Inline Styles */
  div[style*="position: absolute"] strong,
  div[style*="position: absolute"] b {
    font-weight: bold !important;
  }
  div[style*="position: absolute"] em,
  div[style*="position: absolute"] i {
    font-style: italic !important;
  }
  
  /* Images */
  div[style*="position: absolute"] img {
    max-width: 100% !important;
    height: auto !important;
    margin: 8px 0 !important;
    display: block !important;
  }
  
  /* Links */
  div[style*="position: absolute"] a {
    color: #0066cc !important;
    text-decoration: underline !important;
  }
`;
  document.head.appendChild(tableStyles);
  document.body.appendChild(tempContainer);

  const images = tempContainer.querySelectorAll("img");
  console.log("Waiting for images to load======", images.length);
  await Promise.all(
    Array.from(images).map(
      (img, idx) =>
        new Promise((resolve) => {
          const checkImage = () => {
            if (img.complete && img.naturalHeight > 0) {
              console.log(`Image ${idx} loaded successfully`);
              resolve();
            } else if (img.complete && img.naturalHeight === 0) {
              console.warn(`Image ${idx} failed to load`);
              resolve();
            } else {
              setTimeout(checkImage, 100);
            }
          };

          img.onload = () => {
            console.log(`Image ${idx} onload triggered`);
            resolve();
          };

          img.onerror = () => {
            console.warn(`Image ${idx} onerror triggered`);
            resolve();
          };
          checkImage();
        })
    )
  );

  await new Promise((resolve) => setTimeout(resolve, 1000));
  const canvas = await html2canvas(tempContainer, {
    scale: 2,
    useCORS: false,
    allowTaint: true,
    backgroundColor: "#ffffff",
    logging: false,
    width: contentWidth * 3.78,
    imageTimeout: 10000,
    onclone: () => {
      console.log("Document cloned for rendering=========");
    },
  });
  document.body.removeChild(tempContainer);
  document.head.removeChild(tableStyles);
  const imgHeight = (canvas.height * contentWidth) / canvas.width;

  let imgY = cursorY;
  let remainingHeight = imgHeight;
  let pageCount = 1;

  while (remainingHeight > 0) {
    const availableHeight = endY - imgY;
    if (availableHeight <= 0) {
      addNewPage();
      pageCount++;
      imgY = startY;
      continue;
    }

    const heightToPrint = Math.min(remainingHeight, availableHeight);
    const sourceY = imgHeight - remainingHeight;
    const croppedCanvas = document.createElement("canvas");
    croppedCanvas.width = canvas.width;
    croppedCanvas.height = (heightToPrint * canvas.width) / contentWidth;

    const ctx = croppedCanvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, croppedCanvas.width, croppedCanvas.height);
    ctx.drawImage(canvas, 0, (sourceY * canvas.width) / contentWidth, canvas.width, croppedCanvas.height, 0, 0, canvas.width, croppedCanvas.height);
    const croppedImgData = croppedCanvas.toDataURL("image/png");
    pdf.addImage(croppedImgData, "PNG", marginX, imgY, contentWidth, heightToPrint);

    imgY += heightToPrint + 2;
    remainingHeight -= heightToPrint;

    if (remainingHeight > 0) {
      addNewPage();
      pageCount++;
      imgY = startY;
    }
  }
  console.log("PDF generation complete. Total pages:", pageNumber);
  const makePdfFileName = (title) => {
    return (
      (title || "Policy Document")
        .trim()
        .replaceAll(/\s+/g, "-")
        .replaceAll(/[^a-zA-Z0-9\-()]/g, "")
        .replaceAll(/-+/g, "-") +
      ".pdf"
    );
  };
  const fileName = makePdfFileName(policy.title);
  const pdfBlob = pdf.output("blob");
  const blobUrl = URL.createObjectURL(pdfBlob);
  const previewWindow = globalThis.open("", "_blank");

  previewWindow.document.write(`
  <html>
    <head>
      <title>${fileName}</title>
      <style>
        body { margin: 0; font-family: Arial; }
        .toolbar {
          display: flex;
          justify-content: flex-end;
        }
        .toolbar a{
          position: absolute;
          top: 12px;
          right: 15px;
          width: 167px;
        }
        button {
          padding: 6px 12px;
          cursor: pointer;
          width: 100%;
        }
        iframe {
          width: 100%;
          height: calc(100vh - 50px);
          border: none;
        }
      </style>
    </head>
    <body>
      <div class="toolbar">
        <a href="${blobUrl}" download="${fileName}">
          <button>Download file</button>
        </a>
      </div>
      <iframe src="${blobUrl}"></iframe>
    </body>
  </html>
`);

};
